module.exports = __webpack_public_path__ + "static/media/counsel5.a4ff9f35.png";